import { Slider as MaterialSlider } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from './Slider.style';

interface Mark {
  value: number;
  label: string;
}

export interface BaseSliderProps {
  min: number;
  max: number;
  step?: number;
  className?: string;
  disabled?: boolean;
  testId?: string;
  marks?: Mark[];
  valueLabelDisplay?: 'on' | 'off';
}

export interface SliderPropsWithFormikArgs extends BaseSliderProps {
  value: number;
  onChange: ((event: React.ChangeEvent<{}>, value: number | number[]) => void);
}

export interface SliderProps extends BaseSliderProps {
  amount: number;
  setAmount: (value: number) => void;
}

export const Slider: React.FC<SliderProps | SliderPropsWithFormikArgs> = ({
  min,
  max,
  step,
  className,
  marks,
  disabled = false,
  valueLabelDisplay = 'off',
  testId = 'amountSlider',
  ...rest
}) => {
  const value = ('value' in rest ) ? rest.value : rest.amount;
  const onChange = ('onChange' in rest )
    ? rest.onChange
    : (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
      rest.setAmount(newValue as number);
      event.preventDefault();
    };

  const c = useStyles({});

  return (
    <div className={clsx(c.root, className, marks && c.withMarks)}>
      <div className={c.sliderWrapper}>
        <MaterialSlider
          className={c.slider}
          data-testid={testId}
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          valueLabelDisplay={valueLabelDisplay}
        />
      </div>
      {marks && marks.length > 0 && (
        <div className={c.marksContainer}>
          {marks.map((mark) => (
            <span key={mark.value} className={c.markLabel}>{mark.label}</span>
          ))}
        </div>
      )}
    </div>
  );
};
